import axios, { AxiosHeaders } from "axios";

export const API_BASE = "https://api.providhapms.com";
export const TOKEN_STORAGE_KEY = "profiler_token";
export const PROFILER_ID_STORAGE_KEY = "profiler_id";

export const apiInstance = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);

  if (token) {
    const headers = AxiosHeaders.from(config.headers);
    headers.set("Authorization", `Bearer ${token}`);
    config.headers = headers;
  }

  return config;
});

export const persistApiSession = ({
  token,
  profilerId,
}: {
  token?: string;
  profilerId?: string | null;
}) => {
  if (token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }

  if (profilerId) {
    localStorage.setItem(PROFILER_ID_STORAGE_KEY, profilerId);
  }
};

export const clearApiSession = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(PROFILER_ID_STORAGE_KEY);
};

export const getStoredToken = () => localStorage.getItem(TOKEN_STORAGE_KEY);
export const getStoredProfilerId = () =>
  localStorage.getItem(PROFILER_ID_STORAGE_KEY);

export const getApiErrorMessage = (error: any, fallback: string) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data;

    if (Array.isArray(responseData?.message) && responseData.message[0]) {
      return responseData.message[0];
    }

    return responseData?.message || responseData?.error || fallback;
  }

  return error?.message || fallback;
};
